import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { 
    open: Boolean,
    id: String // 用于持久化的唯一标识
  }

  connect() {
    // 优先从本地存储读取状态
    const savedState = localStorage.getItem(`menu_open_${this.idValue}`)
    
    // 如果本地有记录，以本地为准；否则以服务器传来的初始值为准
    if (savedState !== null) {
      this.openValue = savedState === "true"
    }

    this.render()
  }

  toggle(e) {
    e.preventDefault()
    this.openValue = !this.openValue
    
    // 保存状态到本地
    localStorage.setItem(`menu_open_${this.idValue}`, this.openValue)
    this.render()
  }

  render() {
    if (this.openValue) {
      this.contentTarget.classList.remove("hidden")
      this.iconTarget.classList.add("rotate-90")
    } else {
      this.contentTarget.classList.add("hidden")
      this.iconTarget.classList.remove("rotate-90")
    }
  }
}